import type { AvailableAddonOfferInsurerRisk, OfferType } from 'BrokerTsLib/src/dtos'
import { useEffect } from 'react'

import { Apps } from '@/dtos'
import { useApp } from '@/hooks/useApp'
import { useGetInsurerInfo } from '../../hooks'
import { RecapExtra } from '../RecapExtra'
import { RecapExtraRowWrapper } from '../RecapExtra/RecapExtraRowWrapper'

export const RecapExtraInsurance = ({ risks, insurerId, offerType }: { risks: AvailableAddonOfferInsurerRisk[], insurerId: number, offerType: OfferType }) => {
  const { app } = useApp()
  const { data, refetch } = useGetInsurerInfo(insurerId, { enabled: false })
  const insurer = data?.data

  useEffect(() => {
    if (!insurer)
      refetch()
  }, [insurerId])

  return (
    <>
      {insurer && risks.length > 0 &&
        <RecapExtra logoProps={{ insurer, height: app == Apps.extra ? 20 : 12, offerType }}>

          {risks.map(risk =>
            <RecapExtraRowWrapper key={risk.riskId} risk={risk} />
          )}
        </RecapExtra>
      }
    </>
  )
}